module.exports = __webpack_public_path__ + "static/media/white-blood-cell.c3a382a1.png";